<div [ngStyle]="contentStyle" class="section pointer-events-none">
  <form
    class="beneficiary-form finxForm"
    [formGroup]="beneficiaryDetailForm"
    (ngSubmit)="submitAddBeneficiaryForm()"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <div class="text-left">
      <div
        *ngIf="
          !enableBeneficiaryFirstAndLastName ||
          (enableBeneficiaryFirstAndLastName && beneficiaryType === ACCOUNTTYPE.BUSINESS)
        "
      >
        <finxone-input
          [type]="'text'"
          [name]="'name'"
          [label]="dataIn?.attri?.widgetProperties['recipientNameLabel']"
          formControlName="name"
          [formControlInvalid]="
            !!(
              beneficiaryDetailForm.controls['name']?.invalid &&
              beneficiaryDetailForm.controls['name']?.touched
            )
          "
          [value]="beneficiaryDetailForm.controls['name']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'required',
              message: 'Field is mandatory'
            },
            {
              type: 'pattern',
              params: '^[A-Za-z\\s\-\.\’]+$',
              message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
            }
          ]"
        >
        </finxone-input>
      </div>

      <div
        *ngIf="enableBeneficiaryFirstAndLastName && beneficiaryType === ACCOUNTTYPE.PERSONAL"
        class="finxForm"
        [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
      >
        <div class="">
          <finxone-input
            [type]="'text'"
            [name]="'firstName'"
            [label]="dataIn?.attri?.widgetProperties['firstNameLabel']"
            formControlName="firstName"
            [formControlInvalid]="
              !!(
                beneficiaryDetailForm.controls['firstName']?.dirty &&
                beneficiaryDetailForm.controls['firstName']?.invalid &&
                beneficiaryDetailForm.controls['firstName']?.touched
              )
            "
            [value]="beneficiaryDetailForm.controls['firstName']?.value ?? ''"
            [validationConfig]="[
              {
                type: 'required',
                message: 'Field is mandatory'
              },
              {
                type: 'pattern',
                params: '^[A-Za-z\\s\-\.\’]+$',
                message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
              }
            ]"
          >
          </finxone-input>
        </div>
        <div>
          <finxone-input
            [type]="'text'"
            [name]="'lastName'"
            [label]="dataIn?.attri?.widgetProperties['lastNameLabel']"
            formControlName="lastName"
            [formControlInvalid]="
              !!(
                beneficiaryDetailForm.controls['lastName']?.dirty &&
                beneficiaryDetailForm.controls['lastName']?.invalid &&
                beneficiaryDetailForm.controls['lastName']?.touched
              )
            "
            [value]="beneficiaryDetailForm.controls['lastName']?.value ?? ''"
            [validationConfig]="[
              {
                type: 'required',
                message: 'Field is mandatory'
              },
              {
                type: 'pattern',
                params: '^[A-Za-z\\s\-\.\’]+$',
                message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
              }
            ]"
          >
          </finxone-input>
        </div>
      </div>
    </div>
    <div class="text-left">
      <div>
        <finxone-input
          [type]="'text'"
          [name]="'iban'"
          [label]="dataIn?.attri?.widgetProperties['ibanLabel'] ?? 'IBAN'"
          formControlName="iban"
          [formControlInvalid]="
            !!(
              beneficiaryDetailForm.controls['iban']?.dirty &&
              beneficiaryDetailForm.controls['iban']?.invalid &&
              beneficiaryDetailForm.controls['iban']?.touched
            )
          "
          [value]="beneficiaryDetailForm.controls['iban']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'invalidIban',
              message: 'This field cannot be empty or invalid.',
              validatorFn: ibanValidator()
            }
          ]"
        >
        </finxone-input>
      </div>
    </div>
    <div class="text-left">
      <div>
        <finxone-input
          [type]="'text'"
          [name]="'bic'"
          [label]="dataIn?.attri?.widgetProperties['bicLabel'] ?? 'BIC (Optional)'"
          formControlName="bic"
          [formControlInvalid]="
            !!(
              beneficiaryDetailForm.controls['bic']?.dirty &&
              beneficiaryDetailForm.controls['bic']?.invalid &&
              beneficiaryDetailForm.controls['bic']?.touched
            )
          "
          [value]="beneficiaryDetailForm.controls['bic']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'invalidBic',
              message:
                'The BIC must have a length of 8 or 11 characters and include only uppercase letters and digits.',
              validatorFn: bicValidator()
            }
          ]"
        >
        </finxone-input>
      </div>
    </div>

    <div class="mt-8" *ngIf="!dynamicZone" [ngStyle]="nestedButtonParentCss">
      <finx-button
        type="submit"
        [labeltext]="buttonContent"
        class="nested-button pointer-events-none d-flex"
        [buttonStyle]="!isAllowedGlobalStyling ? submitButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
        [style.height]="'100%'"
        [class.mandatory-cta-button]="!isAllowedGlobalStyling"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
  </form>
</div>
